import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { type CaseSearchItemWithHistory } from '../../types'

export const getCaseInformationWithHistoryQueryKey = (caseId?: number) => [API_ENDPOINTS.business.v2.case.index, caseId]
export const caseInformationWithHistoryQuery = (caseId?: number) =>
  queryOptions<CaseSearchItemWithHistory>({
    queryKey: getCaseInformationWithHistoryQueryKey(caseId),
    queryFn: () => {
      if (!caseId) {
        throw new Error('Case ID is required to fetch case information')
      }
      return w.get(`${API_ENDPOINTS.business.v2.case.index}/${caseId}?flag=3`).json()
    },
  })
